'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _jockey = require('@souche-f2e/jockey');

var _jockey2 = _interopRequireDefault(_jockey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Promise = require('es6-promise').Promise;

// 浏览器顶部设置
module.exports = {
	/**
  * @desc 打开拍照和选取图片
  * @param {Function/Number/Object} params 直接传回调函数，写cb不用穿
  *      maxPicCount      {Number}    最多选择照片                 必传
  *      startNum         {Number}    当前已选照片                 可选
  *      type             {String}    判断来源                     可选   车牛发车： cheniu_car    拍卖发车：auction_car   默认：normal
  *      pickerType       {String}    判断当前掉漆拍照或者选取图片   可选   拍照： camera            选取图片  album        默认：normal
  * @param {Function} cb  回调函数
  *       回调数据： 不传数量，或者数量为1，会返回String的图片url。  数量大于2，会返回图片的url数组
  */
	uploadImg: function uploadImg(param) {
		var data = {
			maxPicCount: 1
		};
		if ((typeof param === 'undefined' ? 'undefined' : _typeof(param)) === 'object') {
			data = param;
		}
		if (typeof param === 'number') {
			data.maxPicCount = param;
		}
		return new Promise(function (resolve) {
			_jockey2.default.send("CapturePicBridge", data, function (res) {
				if (data.maxPicCount === 1) {
					resolve(res.urls[0]);
					return;
				}
				resolve(res.urls);
			});
		});
	},

	/**
  * @desc 图片裁剪
  * @param {String}   url    图片地址  
  * @param {Number}   width  图片结果的宽
  * @param {Number}   height 图片结果的高
  * @param {Function} cb      回调函数
  *       回调数据： 图片的url
  */
	cutImg: function cutImg(url, width, height) {
		return new Promise(function (resolve) {
			_jockey2.default.send("CutImageBridge", {
				width: width,
				height: height,
				imageUrl: url
			}, function (res) {
				resolve(res.url);
			});
		});
	},

	/**
  * @desc  查看大图
  * @param {Object}   params    查看大图的资源
  *      pics            {Array}    url路径数组       必传
  *      index           {Number}   当前图片位置      可选   默认： 0
  *      enableDelete   {Boolean}  是否允许操作删除   可选  默认: false
  * @param {Function} cb      回调函数 可选参数
  *       回调数据： 删除的第几张图片
  */
	seeBigImg: function seeBigImg(data, cb) {
		data.enableDelete = data.enableDelete ? 1 : 0;
		_jockey2.default.send("BrowsePicBridge", data, function (res) {
			cb && cb(res.actionIndex);
		});
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/~/@souche-f2e/tower/lib/img.js
// module id = 267
// module chunks = 4